import React from 'react';

import Modal from '../Modal/Modal';
import Button from '../UI/Button';

/**
 * Simple confirmation dialog built on top of the generic Modal component.
 * It replaces native browser confirm() calls so the UI feels consistent.
 */
const ConfirmModal = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel = 'OK',
  cancelLabel = 'Abbrechen',
  hideCancel = false,
}) => {
  const footer = (
    <div className='px-6 py-4 bg-gray-50 dark:bg-gray-700 flex justify-end space-x-2'>
      {!hideCancel && (
        <Button
          variant='secondary'
          onClick={onCancel}
          iconLeft={null}
          iconRight={null}
          className=''
        >
          {cancelLabel}
        </Button>
      )}
      <Button
        variant='primary'
        onClick={onConfirm}
        iconLeft={null}
        iconRight={null}
        className=''
      >
        {confirmLabel}
      </Button>
    </div>
  );

  return (
    <Modal isOpen={isOpen} title={title} onClose={onCancel} footer={footer}>
      <p className='whitespace-pre-wrap'>{message}</p>
    </Modal>
  );
};

export default ConfirmModal;
